import styled from "styled-components";

const ParentList = styled.ul`
  margin: 0;
  padding: ${({ mobile }) => (mobile ? "20px 0 0 0" : "0")};
  list-style: none;
`;

export default ParentList;
